import { OptionType } from "@portal/BaseComponents/CheckBox/type";
import { MultiSelectElement } from "@portal/BaseComponents/Filters/Elements/MultiSelect/MultiSelectElement";
import { FilterDropdownDown } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropdownDown";
import useOpen from "@portal/hooks/useOpen";
import { paymentFiltersAtom } from "@portal/store/Filters/payments/payments-filter";
import { getPaymentModeOptions } from "@portal/store/Filters/payments/predicate";
import { resetPage, tableAtom } from "@portal/store/table/table";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";
import { useMemo } from "react";
import { getPaymentModeLabel } from "../../predicate";
import { useGetPaymentModeQuery } from "@portal/queries/payment-query";
import { getMultiSelectDisplayValue } from "@portal/BaseComponents/Filters/utils/multiSelectDisplayUtils";

const paymentModeLabelPredicate = (option: string) =>
  getPaymentModeLabel(option);
function PaymentModeFilter() {
  const { onClose, open, toggleOpen, handleOpenChange } = useOpen({
    open: false,
  });
  const { data: paymentModes, isLoading: paymentModeLoading } =
    useGetPaymentModeQuery();
  const setTable = useSetAtom(tableAtom);
  const [paymentFilters, setPaymentFilters] = useAtom(paymentFiltersAtom);

  function getSelectedFilterValues() {
    return getMultiSelectDisplayValue({
      selectedValues: paymentFilters.filterValues.modes ?? [],
      allOptions: paymentModes?.list ?? [],
      labelMapper: paymentModeLabelPredicate,
      includeUnassigned: true,
    });
  }

  function handleHideReset() {
    return !paymentFilters.filterValues.modes?.length;
  }

  function handleReset() {
    setPaymentFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.modes = [];
      });
    });
    setTable(resetPage);
    onClose();
  }

  function handleRemove() {
    setPaymentFilters((filter) => {
      return produce(filter, (draft) => {
        draft.activeFilterKeys = draft.activeFilterKeys.filter(
          (mode) => mode !== "modes"
        );
      });
    });
    setPaymentFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.modes = [];
      });
    });
    setTable(resetPage);
    onClose();
  }
  const selectedValues = useMemo(getSelectedFilterValues, [
    paymentFilters.filterValues.modes,
    paymentModes?.list,
  ]);

  const options = useMemo(
    () => getPaymentModeOptions(paymentModes),
    [paymentModes]
  );

  function handleSubmit(
    optionValue: OptionType["value"][]
  ) {
    const value = optionValue as string[];
    setPaymentFilters((prev) =>
      produce(prev, (draft) => {
        draft.filterValues.modes = value;
      })
    );
    setTable(resetPage);
    onClose();
  }
  const Content = (
    <MultiSelectElement
      multiSelectProps={{
        initialValue: paymentFilters.filterValues.modes,
        options,
        loading: paymentModeLoading,
        onSubmit: handleSubmit,
        onCancel: onClose,
        shouldIncludeUnassigned: true,
      }}
    />
  );
  const hideReset = handleHideReset();
  return (
      <FilterDropdownDown
        filterBlockProps={{
          toggleOpen,
          open,
          title: "Payment Mode",
          filterValues: selectedValues,
          onReset: handleReset,
          onRemove: handleRemove,
          isDefault: true,
          hideReset,
        }}
        filterComponent={Content}
        filterTitle={"Payment Mode"}
        onopenChange={handleOpenChange}
      />
  );
}

export { PaymentModeFilter };
